import * as Sentry from '@sentry/nuxt'
import type { ErrorEvent, TransactionEvent } from '@sentry/core'

const { sentry } = useRuntimeConfig().public

// Only initialize Sentry if DSN is provided and not empty
if (sentry.dsn && sentry.dsn.length) {
  Sentry.init({
    dsn: sentry.dsn,
    sendDefaultPii: true,
    tracesSampleRate: Number(sentry.tracesSampleRate),
    debug: process.env.NODE_ENV === 'development',
    environment: process.env.NUXT_PUBLIC_ENVIRONMENT,
    beforeSend(event: ErrorEvent) {
      // Add app name as tag
      if (event.tags) {
        event.tags.app = 'platform'
      } else {
        event.tags = { app: 'platform' }
      }
      return event
    },
    beforeSendTransaction(event: TransactionEvent) {
      // Filter out health checks and static assets
      if (
        event.transaction?.includes('/health') ||
        event.transaction?.includes('/_nuxt/') ||
        event.transaction?.includes('/favicon')
      ) {
        return null
      }
      return event
    },
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
  })
}
